import type { FC } from "react"
import { Fragment } from "react"

import type { Point2d } from "@logic/lib/2d"
import { studioToScreen } from "@logic/lib/design"
import { useRecoilValue } from "recoil"

import { zoomState } from "~/containers/LegacyDesigner/state/view"
import { getRainbow, wrapInto } from "~/utils/getRainbow"

const calculateOpacity = (
  specimen: [number, number],
  position: [number, number],
): number =>
  specimen[0] !== position[0]
    ? 0.1
    : specimen[1] < position[1]
      ? 0.5
      : specimen[1] === position[1]
        ? 1
        : 0.1

export const RainbowFacesPlayback: FC<{
  nodeGroups: Point2d[][]
  playbackPosition: [number, number]
}> = ({ nodeGroups, playbackPosition }) => {
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {nodeGroups.map((points, i, { length }) => {
        const color = getRainbow(i)

        return (
          <g key={`rainbowFace` + i}>
            {points.map((point1, j) => {
              const point2 = wrapInto(j + 1, points)
              const screenPoint1 = studioToScreen.point(point1, zoom)
              const screenPoint2 = studioToScreen.point(point2, zoom)
              const opacity = calculateOpacity([i, j], playbackPosition)

              return (
                <Fragment key={JSON.stringify(point1) + j}>
                  <line
                    key={JSON.stringify(point1) + j}
                    x1={screenPoint1.x}
                    y1={screenPoint1.y}
                    x2={screenPoint2.x}
                    y2={screenPoint2.y}
                    stroke={color}
                    strokeWidth={8}
                    opacity={opacity}
                  />
                  {playbackPosition[1] === j && playbackPosition[0] === i && (
                    <>
                      <circle
                        key={JSON.stringify(point2) + j}
                        cx={screenPoint2.x}
                        cy={screenPoint2.y}
                        r={20}
                        opacity={opacity}
                        fill={`none`}
                        stroke="black"
                      />
                      <circle
                        key={`circle` + JSON.stringify(point1) + j}
                        cx={screenPoint1.x}
                        cy={screenPoint1.y}
                        r={20}
                        opacity={opacity}
                        fill={`none`}
                        stroke={color}
                      />
                    </>
                  )}
                  {/* {shouldLabel && point.id && (
                    <CoordinateTooltip says={point.id} where={screenPoint} />
                  )} */}
                </Fragment>
              )
            })}
          </g>
        )
      })}
    </>
  )
}
